module.exports = __webpack_public_path__ + "static/media/activ.6529fa0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/kz_pay/activ.svg
// module id = 880
// module chunks = 7